"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reportingMessage_1 = require("../reportingMessage");
exports.default = (function () { return (React.createElement(reportingMessage_1.default, { iconName: "icon-no-results", title: "Oops! we couldn't find any results", message: "Try to modify the date range or remove filters and constraints" })); });
